import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { QuizProvider } from "../contexts/QuizContext.jsx"; // Import QuizProvider
import { TeachingModeProvider } from "../contexts/TeachingModeContext.jsx"; // Import TeachingModeProvider
import { ClearChatProvider } from "../contexts/ClearChatContext.jsx"; // Import ClearChatProvider
import AdventurePathPage from "../pages/AdventurePathPage";
import UploadTestsPage from "../pages/UploadTestsPage";
import ChallengesPage from "../pages/ChallengesPage";
import Questions from "../components/questions";
import SamplePaper from "../pages/SamplePaperPage";
import SampleWorksheet from "../pages/SampleWorksheetPage_New.jsx";
import GeneratedWorksheets from "../pages/GeneratedWorksheets";
import GeneratedPapers from "../pages/GeneratedPapers";
import Playwithfriends from "../pages/PlayWithFriendsPage";
import PlayWithFriends_Challenge from "../pages/PlayWithFriendsPage_Challenge";
import Demo from "../components/demo";
import Logout from "../pages/Logout";
import NotesPractice from "../components/NotesPractice";
import DoubtSolver from "../components/DoubtSolver";
import EvaluateAnswers from "../components/EvaluateAnswers";
import QuestionSolver from "../components/QuestionSolver";
import GoalQuestions from "../components/GoalQuestions_new.jsx";
import Button from "../components/common/Button";
import HomePage from "../components/HomePage";
import Home from "../common/Home";
import Practice from "../pages/Practice";
import MyGoals from "../components/MyGoals";
import GrowthAreaFocus from "../components/GrowthAreaFocus";
import TopicExplorer from "../components/TopicExplorer";
import SelfAssessmentPage from "../components/SelfAssessmentPage";
import Tutor from "../pages/Tutor";
import TeachMeTopic from "../components/TeachMeTopic";
import Dashboard from "../components/Dashboard.jsx";
import CreateGoal from "../components/CreateGoal";
import SkillGoal from "../components/SkillGoal.jsx";
import LeaderboardPage from "../components/LeaderboardPage";
import AuthForm from "../components/AuthForm.jsx";
import Quiz from "../pages/Quiz.jsx";
import Results from "../pages/Result.jsx";
import DashboardPage from "../pages/DashboardPage.jsx";
import StrengthAreas from "../components/StrengthAreas.jsx";
import GrowthAreas from "../components/GrowthAreas.jsx";
import OverallProgress from "../components/OverallProgress.jsx";
import Goalpage from "../pages/Goalpage.jsx";
import WaitingRoom from "../components/WaitingRoom.jsx";
import ProtectedRoute from "./ProtectedRoute.jsx";
import Profile from "../components/Profile.jsx";
import ChallengeLog from "../pages/ChallengeLog.jsx";
import ReviewQuiz from "../pages/ReviewQuiz.jsx";
import ForgotPassword from "../components/ForgotPassword.jsx";
import EvaluateAnswerSheet from "../components/EvaluateAnswerSheet_new.jsx";
import Feedback from "../components/Feedback.jsx";
import LatextRendering from "../components/LatexRendering.jsx";
import Admin from "../pages/Admin.jsx";
import AdminDashboard from "../pages/AdminDashboard.jsx";
import AdminQuestions from "../pages/AdminQuestions.jsx";
import AdminFeedback from "../pages/AdminFeedback.jsx";
import AdminQBSummary from "../pages/AdminQBSummary.jsx";
import AdminItemAnalysis from "../pages/AdminItemAnalysis.jsx";
import AdminStudentActivity from "../pages/AdminStudentActivity.jsx";
import AdminCreateUser from "../pages/AdminCreateUser.jsx";
import MobileLogin from "../pages/MobileLogin.jsx";
import MobileOtp from "../pages/MobileOtp.jsx";
import Onboarding from "../pages/Onboarding.jsx";
import PublicEvaluateAnswerSheet from "../pages/PublicEvaluateAnswerSheet.jsx";
import NewHomeComponent from "../components/NewHomeComponent.jsx";
import NewHomeComponent2 from "../components/NewHomeComponent2.jsx";
import NewLearnComponent from "../components/NewLearnComponent.jsx";
import NewLearnComponent2 from "../components/NewLearnComponent2.jsx";
import {
  deactivateMasteryFlow,
  isMasteryFlowActive,
} from "../utils/masteryFlow";
const PlaceholderPage = ({ pageName }) => {
  const navigate = useNavigate();

  return (
    <div className="">
      <div className="content-card">
        <div className="placeholder-content">
          <h2>{pageName} Page</h2>
          <p>This feature is coming soon!</p>
          <div className="action-buttons-row">
            <Button variant="primary" onClick={() => navigate("/")}>
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const AppRoutes = () => {
  const [isLogged, setIsLogged] = useState(!!localStorage.getItem("userToken"));
  const location = useLocation();

  useEffect(() => {
    const pathname = location?.pathname || "";
    const withinPractice = pathname.startsWith("/practice");
    if (!withinPractice && isMasteryFlowActive()) {
      deactivateMasteryFlow();
    }
  }, [location?.pathname]);

  return (
    <QuizProvider>
      {" "}
      {/* Wrap Routes with QuizProvider */}
      <TeachingModeProvider>
        <ClearChatProvider>
          <Routes>
              <Route path="/latexRendering" element={<LatextRendering />} />

              <Route
                path="/login"
                element={<AuthForm setIsLogged={setIsLogged} />}
              />
              <Route path="/login/mobile" element={<MobileLogin />} />
              <Route path="/login/mobile/verify" element={<MobileOtp />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/practice/evaluateAnswerSheet/:id"
                element={<PublicEvaluateAnswerSheet />}
              />
              <Route
                path="/evaluateanswersheet/:id"
                element={<PublicEvaluateAnswerSheet />}
              />
              <Route
                path="/evaluateanswersheet"
                element={
                  <Navigate to="/practice/evaluateAnswerSheet" replace />
                }
              />
              <Route element={<ProtectedRoute />}>
                <Route
                  path="/challenge/waiting/:challengeId"
                  element={<WaitingRoom />}
                />
                <Route path="/assessment" element={<SelfAssessmentPage />} />
                <Route path="/onboarding" element={<Onboarding />} />
              </Route>
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<HomePage />}>
                  <Route index element={<LeaderboardPage />} />
                  <Route
                    path="assessment/challenge"
                    element={<ChallengesPage />}
                  />
                  <Route
                    path="/assessment/upload-tests"
                    element={<PlaceholderPage pageName="UploadTestsPage" />}
                  />
                  <Route path="practice" element={<Practice />}>
                    <Route index element={<Navigate to="mygoals" replace />} />
                    <Route path="mygoals" element={<MyGoals />}>
                      <Route path="goals" element={<Goalpage />} />
                    </Route>
                    <Route
                      path="playwithfriends"
                      element={<Playwithfriends />}
                    />
                    <Route
                      path="goalquestions/:topicId"
                      element={<GoalQuestions />}
                    />
                    <Route path="growth" element={<GrowthAreaFocus />} />
                    <Route
                      path="explorer"
                      element={<PlaceholderPage pageName="TopicExplorer" />}
                    />
                    <Route path="notes" element={<NotesPractice />} />
                    <Route path="teachMeTopic" element={<TeachMeTopic />} />
                    <Route path="sampleWorksheet" element={<SampleWorksheet />}>
                      <Route
                        path="generated"
                        element={<GeneratedWorksheets />}
                      />
                    </Route>
                    <Route
                      path="evaluateAnswerSheet"
                      element={<EvaluateAnswerSheet />}
                    />
                    <Route path="samplePapers" element={<SamplePaper />}>
                      <Route path="generated" element={<GeneratedPapers />} />
                    </Route>
                    <Route path="tutor" element={<Tutor />}>
                      <Route index element={<DoubtSolver />} />
                      <Route path="teachMeTopic" element={<TeachMeTopic />} />
                      <Route path="evaluate" element={<EvaluateAnswers />} />
                    </Route>
                  </Route>
                  <Route
                    path="/practice/playwithfriends-Challenge"
                    element={<PlayWithFriends_Challenge />}
                  />
                  <Route path="/practice/quiz" element={<Quiz />} />
                  <Route path="/practice/results" element={<Results />} />
                  <Route path="/practice/review" element={<ReviewQuiz />} />
                  <Route path="tutor" element={<Tutor />}>
                    <Route index element={<DoubtSolver />} />
                    <Route path="teachMeTopic" element={<TeachMeTopic />} />
                    <Route path="evaluate" element={<EvaluateAnswers />} />
                  </Route>
                  <Route path="feedback" element={<Feedback />} />
                  <Route path="dashboard" element={<DashboardPage />}>
                    <Route index element={<StrengthAreas />} />
                    <Route path="growth" element={<GrowthAreas />} />
                    <Route path="progress" element={<OverallProgress />} />
                    <Route path="goals" element={<Goalpage />} />
                    {/* <Route path="challenges" element={<ChallengeLog />} /> */}
                  </Route>
                  <Route path="/profile-update" element={<Profile />} />
                </Route>
              </Route>
              <Route path="/adventure" element={<AdventurePathPage />} />
              <Route path="/upload-tests" element={<UploadTestsPage />} />
              <Route path="/math-challenges" element={<ChallengesPage />} />
              <Route
                path="/subjects"
                element={<PlaceholderPage pageName="Subjects" />}
              />
              <Route
                path="/progress"
                element={<PlaceholderPage pageName="Progress" />}
              />
              <Route
                path="/rewards"
                element={<PlaceholderPage pageName="Rewards" />}
              />
              <Route
                path="/community"
                element={<PlaceholderPage pageName="Community" />}
              />
              <Route
                path="/achievements"
                element={<PlaceholderPage pageName="Achievements" />}
              />
              <Route
                path="/settings"
                element={<PlaceholderPage pageName="Settings" />}
              />
              <Route path="/sample-paper" element={<SamplePaper />} />
              <Route path="/doubt" element={<DoubtSolver />} />
              <Route path="/questionSolver" element={<QuestionSolver />} />
              <Route path="/questions/:topicId" element={<Questions />} />
              <Route path="/create-goals" element={<CreateGoal />} />
              <Route path="/skill-improvement" element={<SkillGoal />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/logout" element={<Logout />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/new-home" element={<NewHomeComponent />} />
                <Route path="/new-home-2" element={<NewHomeComponent2 />} />
                <Route path="/new-learn" element={<NewLearnComponent />} />
                <Route path="/new-learn-2" element={<NewLearnComponent2 />} />
              </Route>
              {/* <Route path="/profile-update" element={<Profile/>}/> */}
              <Route path="/asjkaska2222/admin" element={<Admin />}>
                <Route
                  index
                  element={<Navigate to="admin-dashboard" replace />}
                />
                <Route path="admin-dashboard" element={<AdminDashboard />} />
                <Route path="admin-questions" element={<AdminQuestions />} />
                <Route path="admin-feedback" element={<AdminFeedback />} />
                <Route path="admin-qb-summary" element={<AdminQBSummary />} />
                <Route
                  path="admin-item-analysis"
                  element={<AdminItemAnalysis />}
                />
                <Route
                  path="admin-student-activity"
                  element={<AdminStudentActivity />}
                />
                <Route path="admin-create-user" element={<AdminCreateUser />} />
              </Route>
          </Routes>
        </ClearChatProvider>
      </TeachingModeProvider>
    </QuizProvider>
  );
};

export default AppRoutes;
